import React from 'react';
import { useNavigate } from 'react-router-dom';
import DeviceActivation from './DeviceActivation';

// Pagina /attiva: permette di attivare un dispositivo con il codice anche
// quando il controllo dispositivi è spento (in quel caso la schermata di
// attivazione non compare da sola). Un dispositivo attivato viene
// riconosciuto dal server e può essere segnato, ad esempio, come dotato di
// lettore badge.
export default function ActivateDevicePage() {
  const navigate = useNavigate();
  return <DeviceActivation onActivated={() => navigate('/')} />;
}
